import FuseNav from './modules/fuse-nav';

if (navigator.platform.substr(0, 2) === 'iP') {
  //iOS (iPhone, iPod or iPad)
  let nav = window.navigator;
  let ua = nav.userAgent;
  if (
    ua.indexOf('Safari') !== -1 &&
    ua.indexOf('Version') !== -1 &&
    !nav.standalone
  ) {
    //Safari (WKWebView/Nitro since 6+)
    loadNav();
  }
} else {
  loadNav();
}

function loadNav() {
  document.addEventListener('DOMContentLoaded', function() {
    const readMore = document.querySelector('.fuse-read-more');
    const nav = new FuseNav(readMore, {
      removeCards: true,
      seriesSequence: true
    });

    nav.init();
  });
}
